import * as serviceContext from './serviceContext';
import { MASTER_REPORT as MasterReportsURL, OPERATOR_ID as OperatorId, staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getMarquee() {

    try {
        const response = await serviceContext.get("marketprovider/marquee", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getBanner() {
    try {
        const response = await serviceContext.get(MasterReportsURL + "banner", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getClientIPOwnApi() {
    try {
        const response = await serviceContext.get("marketprovider/device/info", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getOperatorBannerListWithOutLoginJson() {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_IMAGE_PATH}/${OperatorId.toLowerCase()}/banners/listwologin.json`)
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })

    // return res;

}

export async function getOperatorBannerListJson() {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_IMAGE_PATH}/${OperatorId.toLowerCase()}/banners/list.json`)
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })

    // return res;

}

export async function getBannerListJson() {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_IMAGE_PATH}/banners/list.json`)
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })

    // return res;
}

// export async function getIpdata() {
//     return new Promise((resolve, reject) => {
//         fetch("https://geolocation-db.com/json/")
//             .then((response) => response)
//             .then((res) => {
//                 resolve(res);
//             })
//     })
// }

// export async function getClientIp() {
//     try {
//         const response = await getIpdata();
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// }

export function formatDate(date) {
    if (!date) {
        return ""
    }
    date = new Date(date)
    let month = [];
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sept";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    let mn = date.getMonth() + 1;
    mn = mn > 9 ? mn : "0" + mn
    let dt = date.getDate();
    dt = dt > 9 ? dt : "0" + dt
    let hr = date.getHours();
    hr = hr > 9 ? hr : "0" + hr
    let min = date.getMinutes();
    min = min > 9 ? min : "0" + min
    let year = date.getFullYear()
    let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
    return formatedDate

}

export async function checkMaintainanceCall() {
    
    try {
        const response = await serviceContext.get(`${ReportsURL}maintenance`, null , options); //+"transactions", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getSplashPopupListJson() {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_IMAGE_PATH}/splashpopup/splashpopuplist.json`) 
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })

    // return res;

}

export async function getOperatorSocialMediaJson() {
    return new Promise((resolve) => {
        fetch(`${BASE_IMAGE_PATH}/${OperatorId.toLowerCase()}/banners/SocialMediaAndNumbers.json`)
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })
};

export async function getWinnerEventDicJson(tm) {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_IMAGE_PATH}/evts/winnereventdic.json?${tm}`)
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })

    // return res;

}